import React from "react";
import MatchCard from "./Match"; // correct import

export default function RoundColumn({ title, matches = [], roundIndex, onWinnerSelect, onMoveFighter, onAutoAdvance }) {
  return (
    <div className="round-column">
      <h2 className="round-title">{title || `Round ${roundIndex + 1}`}</h2>

      {(matches || []).map((match, idx) => (
        <MatchCard
          key={match?.id || `${roundIndex}-${idx}`}
          match={match}
          matchNumber={`${roundIndex + 1}-${idx + 1}`}
          onWinnerSelect={onWinnerSelect}
          onMoveFighter={onMoveFighter}
          onAutoAdvance={onAutoAdvance}
        />
      ))}
    </div>
  );
}
